module.exports = __webpack_public_path__ + "static/media/table-tennis.7924a177.png";